module.exports = __webpack_public_path__ + "img/Menu-03.83d1c8ad.webp";